export default __webpack_public_path__ + "static/grief_square-2d499d25f12bc4ca1db70a190a2c63b9.jpg";